/**
 * @generated SignedSource<<5d1fd8dbbe493f68dbc44d25b645faf5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GuildEventsPastCard_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EventList_query">;
  readonly " $fragmentType": "GuildEventsPastCard_query";
};
export type GuildEventsPastCard_query$key = {
  readonly " $data"?: GuildEventsPastCard_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"GuildEventsPastCard_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GuildEventsPastCard_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventList_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "a56f7d63c3d59fd5566c830ef55931b9";

export default node;
